<template>
    <div>
        <OrderDataPreviewsDialog
            :is-open="orderDataPreviewsDialog"
            :previews="selectedOrderPreviews"
            @on-close="closeOrderDataPreviewsDialog"
        />
        <v-row v-for="order in orders" :key="order.orderNumber" no-gutters justify="space-between" class="align-center">
            <v-col cols="auto">
                <img 
                    v-if="order.previews.length" 
                    :src="getPreviewImageUrl(order.previews[0])" 
                    width="100px" 
                    height="60px" 
                    @click="openOrderDataPreviewsDialog(order.previews)"
                >
                <i v-if="!order.previews.length">Brak podglądu</i>
            </v-col>
            <v-col cols="auto">
                {{ order.orderNumber }}
            </v-col>
            <v-col cols="auto">
                {{ order.productName }}
            </v-col>
            <v-col cols="auto">
                <v-btn
                    :color="order.isSent ? 'success' : 'primary' "
                    outlined
                    data-sentry-label="Nadaj"
                    :disabled="order.isSent || order.sendingBlocked"
                    @click="showSendings(order.orderNumber)"
                >
                    {{ order.isSent ? 'Nadane' : 'Nadaj' }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row no-gutters justify="space-between">
            <v-col cols="auto">
                <v-btn
                    color="primary"
                    outlined
                    class="mt-3 mb-2"
                    data-sentry-label="Wstecz"
                    @click="showPreviousStep"
                >
                    Wstecz
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { apiConfig } from '@/config'
import { errorHandler } from '@/utils/errorHandler'
import { EventBus } from '@/utils/eventBus'
import OrderDataPreviewsDialog from './OrderDataPreviewsDialog.vue'

export default {
    name: 'OrderData',

    components: {
        OrderDataPreviewsDialog
    },

    props: {
        reportData: {
            type: Object,
            default: null
        },
    },

    data() {
        return {
            orders: null,
            selectedOrderPreviews: null,
            orderDataPreviewsDialog: false
        }
    },

    watch: {
        reportData() {
            this.getOrders()
        }
    },

    mounted() {
        this.getOrders()
    },

    methods: {
        showPreviousStep() {
            this.$emit('show-previous-step')
        },

        showSendings(orderNumber) {
            this.$emit('order-loading', true)
            this.$emit('show-next-step')
            EventBus.$emit('getOrder', orderNumber)
        },

        async getOrders() {
            return await this.$store.dispatch('reports/getOrdersOfJob', {
                primaryNumber: this.reportData.objectNumber,
                plateNumber: this.reportData.plateNumber
            })
                .then(response => {
                    this.orders = response.data.results
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.$emit('order-loading')
                })
        },

        getPreviewImageUrl(image) {
            const mediaRoot = apiConfig.FACTORYBASE_API_URI

            return `${mediaRoot}${image.path}`
        },

        openOrderDataPreviewsDialog(previews) {
            this.selectedOrderPreviews = previews
            this.orderDataPreviewsDialog = true
        },

        closeOrderDataPreviewsDialog() {
            this.orderDataPreviewsDialog = false
        }
    }
}

</script>